export const CyPlaylist = {
  ButtonRemove: "ButtonRemove",
  ButtonDoneAdding: "ButtonDoneAdding",
  AlertUnknownSongs: "AlertUnknownSongs",
  Title: "PlaylistTitle",
  ButtonSaveAsOwnPlaylist: "ButtonSaveAsOwnPlaylist",
  PreviewInfo: "PreviewInfo",
} as const;
